// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_MHHX5 clearfix","tabItem":"index_tabItem_j7Cpz","active":"index_active_SxcuW","select":"index_select_-xLTd clearfix"};